'use strict';

var utils = require('lyonscg/util/utils');

module.exports = $.extend(utils, {
    /**
     * @desc Media breakpoints that are used throughout the Javascript
     */
    breakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        th: 1025,
        xl: 1440
    }
});
